import { CircularProgress } from '@mui/material';
import { ContentsHeader } from '../../../components/common/ContentsHeader/index.tsx';
import { CreateFormClientTableContent } from '../../../components/pushNotification/CreateFormClientTableContent/index.tsx';
import { ClientType } from '../../../types/resources/ClientType.ts';
import { ActionTableColumnsType } from '../../../types/table/ActionTableColumnsType.ts';
import { ActionTableSortParamsType } from '../../../types/table/ActionTableSortParamsType.ts';
import { handleSorting } from '../../../utils/sortings.ts';
import styles from './styles.module.scss';

type Props = {
  fetchClientsData: ClientType[];
  setFetchClientsData: (fetchClientsData: ClientType[]) => void;
  sortParams: ActionTableSortParamsType;
  setSortParams: (sortParams: ActionTableSortParamsType) => void;
  isLoading: boolean;
  selectedClientIds: number[];
  setSelectedClientIds: React.Dispatch<React.SetStateAction<number[]>>;
  selectAllState: true | false | 'indeterminate';
  setSelectAllState: React.Dispatch<React.SetStateAction<true | false | 'indeterminate'>>;
};

export const ClientList: React.FC<Props> = ({
  fetchClientsData,
  setFetchClientsData,
  sortParams,
  setSortParams,
  isLoading,
  selectedClientIds,
  setSelectedClientIds,
  selectAllState,
  setSelectAllState,
}) => {
  const tableHeader: ActionTableColumnsType[] = [
    { label: '', key: 'checkbox', sortable: false, filterable: false },
    { label: '企業名', key: 'name', sortable: false, filterable: false },
    { label: '利用者数', key: 'user_count', sortable: false, filterable: false },
  ];

  const toggleSelectForRow = (row: ClientType) => {
    const isChecked = selectedClientIds.includes(row.id);
    if (isChecked) {
      setSelectedClientIds(prev => prev.filter(id => id !== row.id));
    } else {
      setSelectedClientIds(prev => [...prev, row.id]);
    }

    setSelectAllState('indeterminate');
  };

  const handleToggleSelectAll = () => {
    if (selectAllState === false || selectAllState === 'indeterminate') {
      setSelectAllState(true);
    } else {
      setSelectAllState(false);
    }
  };

  const renderCheckbox = (row: ClientType) => {
    const isChecked = selectedClientIds.includes(row.id);

    return (
      <input
        type='checkbox'
        checked={isChecked}
        onChange={e => {
          e.stopPropagation();
          toggleSelectForRow(row);
        }}
        onClick={e => e.stopPropagation()}
        aria-label='企業を選択'
      />
    );
  };

  return (
    <div className={styles.Root} data-testid='client-page'>
      <ContentsHeader title='配信対象企業' className={styles.noMargin} />
      <div className={styles.tableContainer}>
        <div>
          {isLoading ? (
            <div className={styles.loading}>
              <CircularProgress size='1rem' color='inherit' />
            </div>
          ) : (
            <>
              <div className={styles.selectionInfoContainer}>
                <div
                  className={`${styles.selectionInfo} ${
                    selectedClientIds.length === 0 ? styles.hidden : ''
                  }`}
                >
                  {selectedClientIds.length > 0 &&
                    `${selectedClientIds.length}件の企業が選択されています。`}
                </div>
              </div>
              <CreateFormClientTableContent
                rows={fetchClientsData}
                columns={tableHeader}
                sortParams={sortParams}
                headerSort={column =>
                  handleSorting(
                    column,
                    sortParams,
                    fetchClientsData,
                    setSortParams,
                    setFetchClientsData
                  )
                }
                handleToggleSelectAll={handleToggleSelectAll}
                renderCheckbox={renderCheckbox}
                toggleSelectForRow={toggleSelectForRow}
                selectAllState={selectAllState}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};
